/*
     Title: Production Process API
     Description: Production Process API
     Author: Iqbal Hossain
     Date: 09-January-2022
     Modified: 09-January-2022
*/

export const PRODUCTION_PROCESS_API = {
  root: '/api/production-process',
  fetch_all: 'api/production-process/fetch-all',
  fetch_by_query: `/api/production-process/fetch-by-query`,
  fetch_by_id: `/api/production-process/fetch-by-id`,
  add: `/api/production-process/add`,
  update: `/api/production-process/update`,
  delete: `/api/production-process/delete`,
  delete_by_range: `/api/production-process/delete-range`
};
